import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE from "../config.js";
import { authFetch } from "../services/authFetch";

// ===========================================================================
// LEMBRETES LATERAIS  (14/09/2026)
// ---------------------------------------------------------------------------
// O que precisa da sua atencao hoje, em QUALQUER tela do sistema.
//
// POR QUE ELE EXISTE, SE JA HA O SINO:
//   O sino do Header e o REGISTRO DO QUE ACONTECEU -- historico, some quando
//   voce le. Este painel e O QUE PRECISA DE VOCE AGORA, e some quando a
//   SITUACAO se resolve (o cliente confirmou, a O.S. andou, o dia passou),
//   nao quando voce clica. Por isso nao tem "marcar como lido": um alerta que
//   se silencia sem resolver nada e um alerta que para de significar algo.
//
// COMO NAO QUEBRA O LAYOUT:
//   Sobrepoe, nao empurra. Nenhuma pagina ganha margem, nenhuma grade e
//   recalculada, nenhuma largura muda. Fica abaixo do Header (z-index 80
//   contra 99) e MUITO abaixo dos modais (9999), entao nunca cobre nada.
//
// DE ONDE VEM:
//   - agendamentos: uma leitura da API ao montar e a cada 5 min (mesma
//     cadencia do sino). Falha silenciosa: sem lembrete, nada quebra.
//   - O.S. paradas: do cache os_cache_tenant_N que o sistema ja mantem --
//     nenhuma chamada a mais.
//
// Sem nada pendente, NEM A ABA aparece. Tela limpa e o estado normal.
// ===========================================================================

const ETAPAS_LEMBRETE = {
  solicitacao:       { rot: "Solicitação",        cor: "#6366f1" },
  pre_cadastro:      { rot: "Pré-cadastro",       cor: "#8b5cf6" },
  orcamento_enviado: { rot: "Orçamento enviado",  cor: "#f59e0b" },
  confirmado:        { rot: "Confirmado",         cor: "#22c55e" },
  convertido_os:     { rot: "Em O.S.",            cor: "#3b82f6" },
};
// Mesma regra do card que ja pisca no quadro de agendamentos.
const ETAPAS_COM_ALERTA = ["pre_cadastro", "orcamento_enviado"];
const HORAS_ALERTA_AG = 48;
// Mesma regra que o Header ja usa para alertar O.S. parada.
const STATUS_OS_ATIVA = ["Recepcao", "Diagnostico", "Aguardando Aprovacao", "Em Servico"];
const HORAS_ALERTA_OS = 24;
const VERMELHO = "#ef4444";

function tenantAtual() {
  try {
    const tk = sessionStorage.getItem("access_token") || localStorage.getItem("access_token");
    if (!tk) return sessionStorage.getItem("tenant_id") || localStorage.getItem("tenant_id") || "1";
    return String(JSON.parse(atob(tk.split(".")[1])).tenant_id || "1");
  } catch {
    return sessionStorage.getItem("tenant_id") || localStorage.getItem("tenant_id") || "1";
  }
}

const dd = (n) => String(n).padStart(2, "0");

// Leitura tolerante de "AAAA-MM-DDTHH:mm[:ss]" e da variante com espaco.
// Nao usa new Date() de proposito: Date interpreta fuso e desloca a hora.
function dataParte(v) {
  const m = String(v || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? m[0] : null;
}
function horaParte(v) {
  const m = String(v || "").match(/[T ](\d{2}):(\d{2})/);
  return m ? m[1] + ":" + m[2] : null;
}
function horasDesde(valor) {
  if (!valor) return 0;
  const t = new Date(valor).getTime();
  if (Number.isNaN(t)) return 0;
  return (Date.now() - t) / 36e5;
}
function tempoLegivel(h) {
  if (h >= 48) { const d = Math.floor(h / 24); return d + (d === 1 ? " dia" : " dias"); }
  const n = Math.round(h);
  return n + (n === 1 ? " hora" : " horas");
}
// Transparencia a partir do hex, sem color-mix() -- que so funciona em
// navegador recente, e isto roda em maquina de oficina.
function alfa(hex, a) {
  const h = String(hex || "").replace("#", "");
  const n = parseInt(h, 16);
  if (h.length !== 6 || Number.isNaN(n)) return "rgba(148,163,184," + a + ")";
  return "rgba(" + ((n >> 16) & 255) + "," + ((n >> 8) & 255) + "," + (n & 255) + "," + a + ")";
}

const CSS_LEMBRETES = `
/* Na faixa vazia do cabecalho, a esquerda. O Header alinha tudo a direita
   (justifyContent:flex-end) e deixa esse espaco livre em TODA tela do
   sistema -- e o unico lugar que nao cobre conteudo de pagina nenhuma.
   Acompanha o recolher da barra lateral sozinha, porque le a mesma variavel
   --sidebar-w que o proprio Header usa (240 -> 60 -> 0 no celular).
   z-index 100: acima do cabecalho (99) e muito abaixo dos modais (9999).
   No celular a lateral some e o cabecalho poe o menu sanduiche a esquerda,
   entao la a aba volta para o canto inferior direito. Breakpoint 720px, o
   mesmo do useIsMobile e do modulo de Checklist. */
.lbr-aba{position:fixed;top:11px;left:var(--sidebar-w,0px);margin-left:24px;z-index:100;
  display:flex;align-items:center;gap:7px;height:38px;padding:0 13px;
  background:rgba(30,39,60,.62);border:1px solid rgba(120,146,196,.22);
  border-radius:10px;cursor:pointer;color:var(--text);
  font-family:inherit;font-size:12px;font-weight:700;
  backdrop-filter:blur(12px) saturate(140%);-webkit-backdrop-filter:blur(12px) saturate(140%);
  box-shadow:inset 0 1px 0 rgba(255,255,255,.1),0 6px 20px -10px rgba(0,0,0,.9);
  transition:transform .2s cubic-bezier(.2,.7,.3,1),border-color .2s,left .22s}
.lbr-aba:hover{transform:translateY(-1px);border-color:var(--accent2)}
.lbr-aba .rot{white-space:nowrap}
@media (max-width:720px){
  .lbr-aba{top:auto;bottom:26px;left:auto;right:0;margin-left:0;
    border-radius:11px 0 0 11px;border-right:none}
  .lbr-aba .rot{display:none}
}
.lbr-aba .n{background:${VERMELHO};border-radius:99px;color:#fff;font-size:10px;font-weight:800;
  padding:1px 6px;box-shadow:0 0 10px 1px rgba(239,68,68,.55);animation:lbr-respira 2.4s ease-in-out infinite}
@keyframes lbr-respira{0%,100%{opacity:1}50%{opacity:.55}}
.lbr-painel{position:fixed;right:0;top:60px;bottom:0;width:min(320px,86vw);z-index:80;
  background:linear-gradient(200deg,rgba(34,44,68,.92),rgba(18,23,36,.94));
  border-left:1px solid rgba(120,146,196,.22);
  backdrop-filter:blur(18px) saturate(140%);-webkit-backdrop-filter:blur(18px) saturate(140%);
  box-shadow:-18px 0 50px -22px rgba(0,0,0,1),inset 1px 0 0 rgba(255,255,255,.1);
  display:flex;flex-direction:column;animation:lbr-entra .34s cubic-bezier(.2,.75,.25,1) both}
@keyframes lbr-entra{from{transform:translateX(100%)}to{transform:none}}
.lbr-item{display:flex;align-items:center;gap:10px;text-align:left;width:100%;
  background:rgba(26,32,53,.6);border:1px solid rgba(120,146,196,.22);
  border-left:3px solid var(--st,#38445f);border-radius:9px;padding:9px 11px;cursor:pointer;
  color:var(--text);font-family:inherit;
  transition:transform .15s,background .15s,border-color .15s;
  animation:lbr-cai .42s cubic-bezier(.2,.75,.3,1) both;animation-delay:calc(140ms + var(--i,0) * 62ms)}
.lbr-item:hover{transform:translateX(-3px);background:rgba(36,45,72,.72)}
@keyframes lbr-cai{from{opacity:0;transform:translateX(26px)}to{opacity:1;transform:none}}
.lbr-item.urgente{border-color:rgba(239,68,68,.55);
  animation:lbr-cai .42s cubic-bezier(.2,.75,.3,1) both,lbr-brasa 2.2s ease-in-out 1.2s infinite;
  animation-delay:calc(140ms + var(--i,0) * 62ms),1.2s}
@keyframes lbr-brasa{0%,100%{box-shadow:0 0 0 0 rgba(239,68,68,0)}50%{box-shadow:0 0 14px -2px rgba(239,68,68,.4)}}
.lbr-x{background:rgba(45,58,86,.7);border:1px solid rgba(120,146,196,.22);border-radius:7px;
  color:var(--text2);cursor:pointer;font-size:13px;line-height:1;padding:4px 9px;font-family:inherit}
.lbr-x:hover{border-color:var(--accent2);color:var(--text)}
@media (prefers-reduced-motion:reduce){.lbr-aba .n,.lbr-item,.lbr-item.urgente,.lbr-painel{animation:none!important}}
`;

export default function LembretesLaterais() {
  const navigate = useNavigate();
  const tenantId = tenantAtual();
  const CHAVE_ABERTO = "lbr_aberto_tenant_" + tenantId;

  const [aberto, setAberto] = useState(() => {
    try { return localStorage.getItem(CHAVE_ABERTO) === "1"; } catch { return false; }
  });
  const [agendamentos, setAgendamentos] = useState([]);

  const alternar = (v) => {
    setAberto(v);
    try { localStorage.setItem(CHAVE_ABERTO, v ? "1" : "0"); } catch {}
  };

  const buscar = useCallback(() => {
    authFetch(API_BASE + "/api/v1/dados/agendamentos/" + tenantId, {})
      .then(r => (r && r.ok ? r.json() : null))
      .then(d => { if (Array.isArray(d)) setAgendamentos(d); })
      .catch(() => {}); // falha silenciosa: sem lembrete, nada quebra
  }, [tenantId]);

  useEffect(() => {
    buscar();
    const t = setInterval(buscar, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, [buscar]);

  // ---- monta as duas listas ----
  const hoje = new Date();
  const chaveHoje = hoje.getFullYear() + "-" + dd(hoje.getMonth() + 1) + "-" + dd(hoje.getDate());

  const precisa = [];
  const doDia = [];

  agendamentos.forEach(a => {
    if (!a || a.status === "cancelado" || a.status === "convertido_os") return;
    const meta = ETAPAS_LEMBRETE[a.status] || ETAPAS_LEMBRETE.solicitacao;
    const h = horasDesde(a.updated_at || a.created_at);
    const parado = ETAPAS_COM_ALERTA.includes(a.status) && h >= HORAS_ALERTA_AG;
    if (parado) {
      precisa.push({
        chave: "ag-" + a.id, hora: "—", cor: VERMELHO, pill: "Parado",
        nome: (a.cliente_nome || a.id) + (a.veiculo ? " · " + a.veiculo : ""),
        sub: meta.rot + " há " + tempoLegivel(h),
        urgente: true, ir: "/agendamentos",
      });
    } else if (dataParte(a.data_agendamento) === chaveHoje) {
      doDia.push({
        chave: "hj-" + a.id, hora: horaParte(a.data_agendamento) || "--:--", cor: meta.cor, pill: meta.rot,
        nome: (a.cliente_nome || a.id) + (a.veiculo ? " · " + a.veiculo : ""),
        sub: a.servico_solicitado || a.id,
        urgente: false, ir: "/agendamentos",
      });
    }
  });
  doDia.sort((a, b) => a.hora.localeCompare(b.hora));

  // O.S. sem movimento -- do cache que o sistema ja mantem, sem chamada nova.
  try {
    const osLista = JSON.parse(localStorage.getItem("os_cache_tenant_" + tenantId) || "[]");
    if (Array.isArray(osLista)) {
      osLista.forEach(os => {
        if (!os || !STATUS_OS_ATIVA.includes(os.status)) return;
        const h = horasDesde(os.updated_at || os._criadoEm);
        if (h >= HORAS_ALERTA_OS) {
          precisa.push({
            chave: "os-" + os.id, hora: "—", cor: "#f59e0b", pill: "O.S.",
            nome: os.id + (os.cliente ? " · " + os.cliente : ""),
            sub: os.status + " há " + tempoLegivel(h),
            urgente: false, ir: "/os",
          });
        }
      });
    }
  } catch {}

  const total = precisa.length + doDia.length;
  if (total === 0) return null;   // nada pendente: nem a aba aparece

  const grupos = [
    ["Precisa de você", precisa],
    ["Hoje na oficina", doDia],
  ].filter(g => g[1].length > 0);

  let i = 0;

  return (
    <>
      <style>{CSS_LEMBRETES}</style>

      {!aberto && (
        <button type="button" className="lbr-aba" onClick={() => alternar(true)}
          title={total + " lembrete(s)"}>
          <span aria-hidden="true">&#128276;</span>
          <span className="rot">Lembretes</span>
          <span className="n">{total}</span>
        </button>
      )}

      {aberto && (
        <aside className="lbr-painel" aria-label="Lembretes">
          <div style={{ alignItems: "center", borderBottom: "1px solid rgba(120,146,196,.22)", display: "flex", gap: 9, padding: "13px 14px 11px" }}>
            <span aria-hidden="true">&#128276;</span>
            <span style={{ flex: 1, fontSize: 13.5, fontWeight: 700 }}>Lembretes</span>
            <button type="button" className="lbr-x" onClick={() => alternar(false)} aria-label="Recolher">&rarr;</button>
          </div>

          <div style={{ display: "flex", flex: 1, flexDirection: "column", gap: 14, overflowY: "auto", padding: 12 }}>
            {grupos.map(([titulo, itens]) => (
              <div key={titulo} style={{ display: "flex", flexDirection: "column", gap: 7 }}>
                <div style={{ alignItems: "center", color: "var(--text3)", display: "flex", fontSize: 9.5, fontWeight: 700, gap: 8, letterSpacing: "0.14em", textTransform: "uppercase" }}>
                  {titulo}
                  <span style={{ background: "rgba(60,75,110,.5)", borderRadius: 20, fontSize: 9, padding: "0 6px" }}>{itens.length}</span>
                  <span style={{ background: "rgba(120,146,196,.22)", flex: 1, height: 1 }} />
                </div>
                {itens.map(l => (
                  <button key={l.chave} type="button"
                    className={"lbr-item" + (l.urgente ? " urgente" : "")}
                    style={{ "--i": i++, "--st": l.cor }}
                    onClick={() => { alternar(false); navigate(l.ir); }}>
                    <span style={{ color: "var(--text)", fontSize: 13, fontWeight: 800, minWidth: 42 }}>{l.hora}</span>
                    <span style={{ display: "flex", flex: 1, flexDirection: "column", gap: 1, minWidth: 0 }}>
                      <span style={{ fontSize: 12.5, fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{l.nome}</span>
                      <span style={{ color: "var(--text3)", fontSize: 10.5, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{l.sub}</span>
                    </span>
                    <span style={{ background: alfa(l.cor, .16), border: "1px solid " + alfa(l.cor, .4), borderRadius: 20, color: l.cor, fontSize: 8.5, fontWeight: 800, letterSpacing: "0.07em", padding: "2px 7px", textTransform: "uppercase", whiteSpace: "nowrap" }}>{l.pill}</span>
                  </button>
                ))}
              </div>
            ))}
          </div>

          <div style={{ alignItems: "center", borderTop: "1px solid rgba(120,146,196,.22)", color: "var(--text3)", display: "flex", fontSize: 11, gap: 8, justifyContent: "space-between", padding: "10px 14px" }}>
            <span>Atualiza sozinho a cada 5 min</span>
            <button type="button" onClick={() => { alternar(false); navigate("/agendamentos"); }}
              style={{ background: "none", border: "none", color: "var(--accent2)", cursor: "pointer", fontFamily: "inherit", fontSize: 11.5, fontWeight: 600, padding: 0 }}>
              Ver todos
            </button>
          </div>
        </aside>
      )}
    </>
  );
}
